export var SwapSubStatusEnum;
(function (SwapSubStatusEnum) {
    SwapSubStatusEnum["DRAFT"] = "draft";
    SwapSubStatusEnum["DEPOSIT_PENDING"] = "deposit_pending";
    SwapSubStatusEnum["DEPOSIT_CONFIRMED"] = "deposit_confirmed";
    SwapSubStatusEnum["DEPOSIT_FAILED"] = "deposit_failed";
    SwapSubStatusEnum["BLOCKED"] = "blocked";
    SwapSubStatusEnum["DEPOSIT_REBALANCING_PENDING"] = "deposit_rebalancing_pending";
    SwapSubStatusEnum["DEPOSIT_REBALANCING_FAILED"] = "deposit_rebalancing_failed";
    SwapSubStatusEnum["DEPOSIT_REBALANCING_CONFIRMED"] = "deposit_rebalancing_confirmed";
    SwapSubStatusEnum["LIQUIDATION_PENDING"] = "liquidation_pending";
    SwapSubStatusEnum["LIQUIDATION_FAILED"] = "liquidation_failed";
    SwapSubStatusEnum["LIQUIDATION_CONFIRMED"] = "liquidation_confirmed";
    SwapSubStatusEnum["EXCHANGE_IN_PROGRESS"] = "exchange_in_progress";
    SwapSubStatusEnum["EXCHANGE_COMPLETED"] = "exchange_completed";
    SwapSubStatusEnum["EXCHANGE_FAILED"] = "exchange_failed";
    SwapSubStatusEnum["WITHDRAW_INTERNAL_REBALANCING_TRANSFER_PENDING"] = "withdraw_internal_transfer_pending";
    SwapSubStatusEnum["WITHDRAW_INTERNAL_REBALANCING_TRANSFER_FAILED"] = "withdraw_internal_transfer_failed";
    SwapSubStatusEnum["WITHDRAW_INTERNAL_REBALANCING_TRANSFER_CONFIRMED"] = "withdraw_internal_transfer_confirmed";
    SwapSubStatusEnum["WITHDRAW_REBALANCING_PENDING"] = "withdraw_rebalancing_pending";
    SwapSubStatusEnum["WITHDRAW_REBALANCING_FAILED"] = "withdraw_rebalancing_failed";
    SwapSubStatusEnum["WITHDRAW_REBALANCING_CONFIRMED"] = "withdraw_rebalancing_confirmed";
    SwapSubStatusEnum["WITHDRAW_IN_PROGRESS"] = "withdraw_in_progress";
    SwapSubStatusEnum["WITHDRAW_COMPLETED"] = "withdraw_completed";
    SwapSubStatusEnum["WITHDRAW_FAILED"] = "withdraw_failed";
    SwapSubStatusEnum["PROCESSING_TRANCHES"] = "processing_tranches";
})(SwapSubStatusEnum || (SwapSubStatusEnum = {}));
//# sourceMappingURL=swap-sub-status.enum.js.map